import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { QuickWidgetConfig, QuickWidgetsState, QuickWidgetTypes } from '../reducer/user.reducer';

const state = (state: RootState) => state

export const selectQuickWidgetConfig = (widgetType: QuickWidgetTypes) => createDraftSafeSelector(state, (store: RootState) => {
    const widgets = store.userStore.userDetails.preferences?.quickWidgets
    return (widgets ? widgets[widgetType] : undefined) as (QuickWidgetConfig | undefined)
})
export const selectQuickWidgets = createDraftSafeSelector(state, (store: RootState) => (store.userStore.userDetails.preferences?.quickWidgets) as (QuickWidgetsState | undefined))
